import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { keyEventsStateSelector } from "redux/selectors/keyEventsSelector";
import { EventTypes } from "utils/enums";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useModal } from "contexts/modal";
import "./scss/TimeLineBar.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import { keyEventsActions } from "redux/features/keyEventsSlice";
const publicPath = `${process.env.PUBLIC_URL}/assets`;

interface ITimeLineBar {
  isExpanded: Boolean;
}
//
const subStractString = (duration: number) => {
  return duration.toString();
};

const collapsedEventsPosition = (events: number) => {
  if (events === 0) return 0;
  return -((events - 1) * 10 + 16) / 2;
};

const TimeLineBar = ({ isExpanded }: ITimeLineBar) => {
  const { isMenuOpen, setisExpanded } = useModal();
  const { activeDuration, timeLineEventData, activeYear } = useSelector(
    keyEventsStateSelector
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const timelineEventsData: any = [];
  const durationPrefix = activeDuration.substring(0, 4);
  let subStrDuration = +durationPrefix;
  let initialActiveDuration = 0;

  const timedata = [
    {
      duration: "1973",
      evernt: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
    },
    {
      duration: "1983",
      evernt: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
    },
    {
      duration: "1993",
      evernt: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
    },
    {
      duration: "2003",
      evernt: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
    },
    {
      duration: "2013",
      evernt: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
    },
    {
      duration: "2023",
    },
  ];
  const previewDuration = ["1973", "1983", "1993", "2003", "2013", "2023"];

  useEffect(() => {
    AOS.init();
  }, []);

  const barDurationsMain = () => {
    return previewDuration?.map((event: any, index: number) => {
      return (
        <p
          key={Math.floor(Math.random() * Date.now() * 1234)}
          className={"zoom-in-font"}
        >
          {event}
        </p>
      );
    });
  };

  const generateEventURL = (event: string) => {
    if (event === EventTypes.normalEvent)
      return `${publicPath}/normal-event_2023-01-27/normal-event.png`;
    if (event === EventTypes.worldEvent)
      return `${publicPath}/world-event_2023-01-27/world-event.png`;
    if (event === EventTypes.keyEvent)
      return `${publicPath}/key-event_2023-01-27/key-event.png`;

    return "";
  };

  const EventsBar = ({ events }: any) => {
    return (
      <div className="events">
        {events?.map(
          (event: any, index: number) =>
            event && (
              <img
                onClick={() => {
                  if (isExpanded) {
                    dispatch(
                      keyEventsActions.setActiveEventCardData({
                        eventData: event,
                      })
                    );
                    dispatch(
                      keyEventsActions.setActiveYear({
                        activeYear: event.year_title,
                      })
                    );
                    navigate(`keyevents/${event.year_title}`);
                  }
                  setisExpanded(false);
                }}
                style={
                  !isExpanded
                    ? { position: "absolute", left: `${index * 10}px` }
                    : {}
                }
                key={Math.floor(Math.random() * Date.now() * 123)}
                src={generateEventURL(EventTypes.normalEvent)}
                alt="event"
              />
            )
        )}
      </div>
    );
  };
  const barDurationsMain_mobile_View = (duration: string, events: any) => {
    return (
      <div className={`barDurationsMain_mobile_View  duration-${duration}`}>
        {isExpanded ? (
          <div
            className="event-durations poppins-400"

            // data-aos-duration="500"
          >
            {<EventsBar events={events} />}
          </div>
        ) : null}

        <p className={"zoom-in-font"}>{duration}</p>
      </div>
    );
  };

  const eventDuration = () => {
    let ActiveDurationIndex = +previewDuration.indexOf(durationPrefix);
    for (let i = 0; i < 9; i++) {
      const latestDuration = +durationPrefix + i + 1;
      previewDuration.splice(
        ActiveDurationIndex + 1,
        0,
        subStractString(latestDuration)
      );
      ActiveDurationIndex++;
    }

    return previewDuration;
  };

  eventDuration().forEach((duration, index) => {
    if (+duration === +subStractString(subStrDuration)) {
      if (initialActiveDuration > 9) return;

      const yearTitle = timeLineEventData[initialActiveDuration]?.year_title;
      const hasSameDuration = yearTitle === duration;

      const events = {
        duration: hasSameDuration ? yearTitle ?? duration : duration,
        events:
          hasSameDuration || yearTitle
            ? [...timeLineEventData[initialActiveDuration]?.year_events]
            : [],
      };

      timelineEventsData.push(events);
      initialActiveDuration++;
      subStrDuration++;
      return;
    }
    timelineEventsData.push({ duration, events: [] });
  });

  const barDurations = () => {
    return timelineEventsData?.map((event: any, index: number) => {
      console.log(window.location.pathname);
      return (
        <>
          {activeYear === event.duration &&
          window.location.pathname !== "/keyevents" ? (
            <div
              key={Math.floor(Math.random() * Date.now() * 1234)}
       
              style={{
                background: "black",
                borderRadius: "5px 5px 0px 0px ",
                color: "white",
                marginTop: "-20px",
                padding: "3px",
                marginLeft: "-3px",
                marginRight: "0px",
                zIndex: "0",
                display: "flex",
                alignItems: "center",
                paddingTop: "10px",
                fontSize: "medium",
              }}
              className={
                event.duration === durationPrefix || !event.events[0]
                  ? "zoom-in-font"
                  : ""
              }
            >
              {event.duration}
            </div>
          ) : (
            <p
              key={Math.floor(Math.random() * Date.now() * 1234)}

              className={
                event.duration === durationPrefix || !event.events[0]
                  ? "zoom-in-font"
                  : ""
              }
            >
              {event.duration}
            </p>
          )}
        </>
      );
    });
  };

  return (
    <>
      {!isMenuOpen && window.location.pathname === "/" ? (
        <>
          <div
            className={`main-time-line-bars-menu-page d-none ${
              isExpanded ? "manu-page" : ""
            }  `}
          >
            {timelineEventsData?.map((event: any) => {
              return (
                <React.Fragment
                  key={Math.floor(Math.random() * Date.now() * 1234)}
                >
                  {barDurationsMain_mobile_View(event.duration, event.events)}
                </React.Fragment>
              );
            })}
          </div>

          <div
            className="main-time-line-bars-menu-page desktop-view"
            data-aos="fade-left"
            data-aos-anchor="#example-anchor"
            data-aos-offset="500"
            data-aos-duration="500"
          >
            {timedata?.map((elem: any) => {
              return (                             
                <React.Fragment
                  key={Math.floor(Math.random() * Date.now() * 12334)}
                >
                  <div className="main-time-line-sub1 time-bar"></div>

                  {elem?.evernt?.map((e: any, index: number) => {
                    return (
                      <div key={index} className="main-time-line-sub2"></div>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </div>
          <div className="footer-durations main-page poppins-400">
            {["1973", "1983", "1993", "2003", "2013", "2023"]?.map((event: any, index: number) => {
      return (
        <p
          key={Math.floor(Math.random() * Date.now() * 1234)}
          className={"zoom-in-font"}
        >
          {event}
        </p>
      );
    })}
          </div>
        </>
      ) : (
        <>
          <div className="time-line-bars-event-mobile-view d-none">
            {timelineEventsData?.map((elm: any, index: number) => {
              return (
                <React.Fragment key={index}>
                  {barDurationsMain_mobile_View(elm.duration, elm.events)}
                </React.Fragment>
              );
            })}
          </div>
          {isExpanded ? (
            <div
              className="event-durations  poppins-400"
              data-aos="fade-right"
              data-aos-anchor="#example-anchor"
              data-aos-offset="500"
              data-aos-duration="500"
            >
              {barDurations()}
            </div>
          ) : null}

          <div className="time-line-bars">
            {timelineEventsData?.map(({ events }: any) => (
              <div
                className={`time-bar ${
                  !isExpanded ? "collapsed-timebar-view" : ""
                }`}
                data-aos="fade-right"
                data-aos-anchor="#example-anchor"
                data-aos-offset="500"
                data-aos-duration="500"
                key={Math.floor(Math.random() * Date.now() * 1234)}
              >
                <div
                  className={`${
                    isExpanded
                      ? "expanded-timeline-view"
                      : "collapsed-timeline-view"
                  }`}
                  style={{
                    left: `${collapsedEventsPosition(events?.length)}px`,
                  }}
                >
                  <EventsBar events={events} />
                </div>
              </div>
            ))}
          </div>
          <div className="footer-durations timeline-footer-with-events poppins-400">
            {barDurations()}
          </div>
        </>
      )}
    </>
  );
};

export default TimeLineBar;
